import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { betOnActionRouteI18n } from '../i18n/bet-on-action-route-i18n';

export function betOnActionRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${betOnActionRouteI18n(config)}`;
}
